import { render } from "./CreateNewCustomerListAudience.vue?vue&type=template&id=3426b8c5&scoped=true"
import script from "./CreateNewCustomerListAudience.vue?vue&type=script&lang=js"
export * from "./CreateNewCustomerListAudience.vue?vue&type=script&lang=js"

import "./CreateNewCustomerListAudience.vue?vue&type=style&index=0&id=3426b8c5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3426b8c5"]])

export default __exports__